import { createContext } from "react";

import type {
	AuthUser,
	ChangePasswordPayload,
	LoginCredentials,
} from "./types";

export type AuthStatus = "loading" | "authenticated" | "unauthenticated";

export type AuthContextValue = {
	status: AuthStatus;
	user: AuthUser | null;
	login: (credentials: LoginCredentials) => Promise<AuthUser>;
	logout: () => Promise<void>;
	changePassword: (payload: ChangePasswordPayload) => Promise<AuthUser>;
	refresh: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextValue | null>(null);
